<script setup lang="ts">
definePageMeta({
  middleware: ['03-pharmacy-related'],
  // onlyPharmacyId: true,
})
</script>

<template>
  <p>{{ $route.name }}</p>
</template>
